export class MovementError extends Error {}
